import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    LeaseType,
} from 'app/enums/label.enums'
import {
    completed,
} from '../Dashboard.types'

const config: SkyNetTableConfig<keyof completed> = {
    name: 'completed',
    tabs: [{
        name: 'Completed',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'quoteNumber',
                labelKey: 'AccountQuotes.quoteNumber',
            },
            {
                name: 'customerQuotationLocationName',
                labelKey: 'AccountQuotes.customerQuotation',
            },
            {
                name: 'accountName',
                labelKey: 'AccountLane.accountCompanyName',
                filterField: 'accountName',
                filterType: FilterType.Array,
            },
            {
                name: 'pricingAccountCompanyName',
                labelKey: 'AccountLane.pricingAccount',
            },
            {
                name: 'leaseType',
                labelKey: 'AccountLane.leaseType',
                filterField: 'leaseType',
                componentName: 'EnumValue',
                filterType: FilterType.Array,
                allowedValuesEnum: LeaseType,
            },
            {
                name: 'pricingResponsible',
                labelKey: 'AccountQuotes.pricingResponsible',
                componentName: 'List',
                filterField: 'pricingResponsible',
                filterType: FilterType.Array,
            },
            {
                name: 'createdBy',
                labelKey: 'KamDashboard.requestor',
                filterField: 'createdBy',
                filterType: FilterType.Array,
            },
            {
                name: 'totalLanes',
                labelKey: 'KamDashboard.totalLanes',
                sorting: false,
            },
            {
                name: 'changedOn',
                labelKey: 'KamDashboard.lastUpdated',
                sorting: false,
                componentName: 'DateTimeCell',
            },
        ],
    }],
}

export default config
